export default {
  computed: {
    wgParams() {
      return this.$store.state.widgetConfig
    },

    iconUrl() {
      return !!this.wgParams && this.wgParams.iconUrl
    },

    privacyPolicyUrl() {
      return this.wgParams.privacyPolicyUrl
    },

    mainSite() {
      return this.wgParams.mainSite
    },

    wgFullscreen() {
      return !!this.$store.state.options && (this.$store.state.options.fullscreen === true || this.$store.state.options.fullscreen == "true")
    },

/*     wgStandAlone() {
      return !!this.$store.state.options && (this.$store.state.options.standAlone === true || this.$store.state.options.standAlone == "true")
    }, */

    wgProviderGuid() {
      return this.$store.state.options.providerGuid
    }
  }
}